import React from "react";

const BannerSection = ({
  heading,
  subheading,
  features,
  bannerp,
}) => {
  return (
    <section className="relative py-16 md:py-20 bg-[#F7F1EA] overflow-hidden">
      {/* Soft Background Effects */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-[#E8C8A7]/20 blur-3xl rounded-full" />
      <div className="absolute bottom-0 right-0 w-64 h-64 bg-[#DDBA99]/15 blur-3xl rounded-full" />

      <div className="relative max-w-[1180px] mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-12">
          <div
            className="
              inline-flex
              items-center
              px-4
              py-2
              rounded-full
              bg-[#FFF4E8]
              border
              border-[#F3DDC7]
              text-[#C26B2E]
              text-[10px]
              tracking-[.18em]
              uppercase
              font-medium
              mb-4
            "
          >
            Why This Experience
          </div>

          <h2
            className="
              text-3xl
              md:text-5xl
              font-bold
              text-[#2A140D]
              leading-tight
              max-w-[760px]
              mx-auto
            "
          >
            {heading}
          </h2>

          {subheading && (
            <p className="mt-5 max-w-[680px] mx-auto text-[#6B5B4F] text-sm md:text-base leading-8">
              {subheading}
            </p>
          )}
        </div>

        {/* Main Layout */}
        <div
          className="
            grid
            grid-cols-1
            lg:grid-cols-[0.95fr_1fr]
            gap-8
            items-stretch
          "
        >
          {/* Left Panel */}
          <div
            className="
              relative
              overflow-hidden
              rounded-[34px]
              bg-[#2A140D]
              p-8
              md:p-10
              shadow-[0_25px_60px_rgba(20,10,0,.10)]
              min-h-[420px]
              flex
              flex-col
              justify-between
            "
          >
            <div className="absolute top-0 right-0 w-60 h-60 bg-[#D8B08B]/10 blur-3xl rounded-full" />

            <div className="relative z-10 flex-1 flex flex-col justify-center">
              <div
                className="
                  text-[#D8B08B]
                  text-[10px]
                  tracking-[.18em]
                  uppercase
                  mb-5
                "
              >
                Designed For Transformation
              </div>

              <h3
                className="
                  text-3xl
                  md:text-5xl
                  font-bold
                  leading-tight
                  text-white
                "
              >
                More than
                <br />
                <span className="text-[#D8B08B]">
                  a retreat.
                </span>
              </h3>

              {bannerp && (
                <p
                  className="
                    mt-6
                    text-white/75
                    text-sm
                    md:text-base
                    leading-8
                    max-w-[480px]
                  "
                >
                  {bannerp}
                </p>
              )}
            </div>

            <div
              className="
                relative
                z-10
                mt-8
                pt-5
                border-t
                border-white/10
                flex
                items-center
                gap-3
              "
            >
              <div className="w-10 h-[2px] bg-[#D8B08B] rounded-full" />

              <span
                className="
                  text-white/60
                  text-[11px]
                  tracking-[.18em]
                  uppercase
                "
              >
                Holistic Wellbeing
              </span>
            </div>
          </div>

          {/* Right Side Cards */}
{/* Right Side Cards */}
<div
  className="
    grid
    grid-cols-1
    sm:grid-cols-2
    gap-5
  "
>
  {features.map((feature, index) => (
    <div
      key={index}
      className="
        group
        relative
        overflow-hidden
        rounded-[28px]
        bg-white/75
        backdrop-blur-xl
        border
        border-white/40
        shadow-[0_15px_40px_rgba(20,10,0,.05)]
        p-6
        min-h-[150px]
        transition-all
        duration-500
        hover:-translate-y-1.5
      "
    >
      <div className="absolute top-0 right-0 w-28 h-28 bg-[#F4D8BE]/20 blur-3xl rounded-full" />
<div className="relative z-10">
  <div
    className="
      w-12
      h-12
      rounded-full
      bg-[#FFF4E8]
      border
      border-[#F3DDC7]
      flex
      items-center
      justify-center
      text-xl
      mb-4
    "
  >
    {feature.icon}
  </div>

  <h3
    className="
      text-secondary
      text-base
      md:text-lg
      font-bold
      font-xl
      mb-2
      leading-tight
    "
  >
    {feature.heading}
  </h3>

  <p
    className="
      text-black
      text-sm
      md:text-[15px]
      leading-7
      font-normal
    "
  >
    {feature.text}
  </p>
</div>
    </div>
  ))}
</div>    </div>
      </div>
    </section>
  );
};

export default BannerSection;